import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  
  routes: [
    {
      path: '/',
      redirect: '/login',
      name: 'Default',
    },
    {
      path: '/demo',
      name: 'Demo',
      component: resolve => require(['@/components/demo/demo.vue'], resolve)
    },
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['@/components/login/login.vue'], resolve)
    },
    //修改密码密码发送邮件
    {
      path: '/sendEmail',
      name: 'Send Email',
      component: resolve => require(['@/components/sendEmail/sendEmail.vue'], resolve),
    },
    //修改密码密码
    {
      path: '/resetPassword',
      name: 'Reset Password',
      component: resolve => require(['@/components/sendEmail/resetPassword.vue'], resolve),
    },
    //修改密码成功
    {
      path: '/sendSuccess',
      name: 'Send Success',
      component: resolve => require(['@/components/sendEmail/sendSuccess.vue'], resolve),
    },
    // 九宫格视频列表
    {
      path: '/videoList',
      name: 'videoList',
      component: resolve => require(['@/components/videoList/videoList.vue'], resolve),
    },
    {
      path: '/notFound',
      name: 'Not Found',
      component: resolve => require(['@/components/notfound/notfound.vue'], resolve),
    },
    {
      path: '/licenseExpired',
      name: 'License Expired',
      component: resolve => require(['@/components/licenseExpired/licenseExpired.vue'], resolve),
    },
    {
      path: '/cameraFullScreen',
      name: 'Camera full Screen',
      component: resolve => require(['@/components/fullScreen/camerafullScreen.vue'], resolve),
    },
    {
      path: '/watchListFullScreen',
      name: 'watchList Full Screen',
      component: resolve => require(['@/components/fullScreen/watchListScreen.vue'], resolve),
    },
    {
      path: '/centerFullScreen',
      name: 'Center Full Screen',
      component: resolve => require(['@/components/fullScreen/centerFullScreen.vue'], resolve),
    },
    {
      path: '/noPermission',
      name: 'No Permission',
      component: resolve => require(['@/components/noPermission/noPermission.vue'], resolve),
    },

    // {
    //   path:'/carParkDashboard',
    //   name:'Car Park Dashboard',
    //   component: resolve => require(['@/components/dashboard/carParkDashboard.vue'],resolve),
    // },
    // {
    //   path:'/carParkMonitoringArea',
    //   name:'Manage Car Park Monitoring Area',
    //   component: resolve => require(['@/components/dashboard/carParkMonitoringArea.vue'],resolve),
    // },
    // 生成Face Tracking Face 报表
    // {
    //   path:'/faceTrackingReport',
    //   name:'Generate Track and Trace Report',
    //   component:resolve => require(['@/components/dashboard/faceTrackingGenerate.vue'],resolve),
    //   meta: {
    //       "layer": 3,
    //       "code": "M_FaceTrackingPublicReport",
    //       "system": "Global",
    //       "permissionType": 1,
    //       "isFirstMenuGroup": false,
    //       "firstMenuCode": "M_UserAccessSystem",
    //       "firstMenu": "User Access",
    //       "secondMenu": "Work Station",
    //       "thirdMenu": "Track and Trace",
    //       "forthMenu": "Generate Report",
    //       "fifthMenu": ""
    //   }
    // },
  ]
})



//////////////////
// WEBPACK FOOTER
// ./src/admin/router/index.js
// module id = null
// module chunks = 